import { SettingsIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import LogoutIcon from "components/Icons/SidebarIcons/LogoutIcon";
import DefaultUserIcon from "components/Icons/TobarIcons/DefaultUserIcon";
import { useAppSelector } from "hooks/store/hooks";
import { useTranslation } from "TranslationContext";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout, selectUserDetails } from "stores/auth/authSlice";
import { selectColorThemeMode } from "stores/ui/uiSlice";
import { cleanLocalStorage, getAuthToken } from "utils/local-storage";
import apiHelper from "services/apiHelper";

const UserIconDropDown = () => {
  const version_env = process.env.REACT_APP_VERSION;
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const { translate } = useTranslation();
  const { email } = useAppSelector(selectUserDetails);
  const navigate = useNavigate();
  const authToken = getAuthToken();
  const [version, setVersion] = useState("");
  useEffect(() => {
    setVersion(version_env);
  }, []);

  const logoutEvent = async() => {
    try {
      await apiHelper(
        `api/user/logout`,
        "get",
        authToken,
        {}
      ); 
    } catch (error) {
      console.error("Logout API error", error);
    } finally {
      logout();
      cleanLocalStorage();
      window.location.reload();
    }
  };
  return (
    <>
      <Menu
        matchWidth
        isLazy
        lazyBehavior="unmount"
        mb={{ sm: "10px", md: "20px", base: "10px" }}
        p={"10px 0px"}
        h="100%"
        bg={`${colorThemeMode}_background`}
      >
        <MenuButton
          className="user"
          as={Button}
          w={{ base: "full", md: "50px" }}
          p={0}
          minW={"10px"}
          h={"50px"}
          borderRadius={"0px"}
          _hover={{ bg: "#00000020" }}
        >
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            gap="1"
          >
            <DefaultUserIcon />
          </Box>
        </MenuButton>
        <MenuList
          zIndex={1002}
          overflow="hidden"
          right={{ base: "-90px", md: "0px" }}
          position={"absolute"}
          minW={{ base: "250px", md: "300px !important" }}
          maxW={{ base: "250px", md: "300px !important" }}
          borderRadius={"4px"}
          marginTop={"-9px"}
          p={0}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          <MenuItem as={Box} p="0px">
            <Box
              p="16px"
              display={"flex"}
              alignItems={"center"}
              bgColor={`${colorThemeMode}_background`}
              color={`${colorThemeMode}_text`}
              w="100%"
            >
              <Image
                w="80px"
                h="80px"
                src="https://picsum.photos/200/300?random=1"
              />
              <Box pl="10px">
                <Text fontSize={"18px"} fontWeight={"400"}>
                  {email?.split("@")[0]}
                </Text>
                <Text>
                  {email?.length > 15 ? email?.slice(0, 15) + "..." : email}
                </Text>
              </Box>
            </Box>
          </MenuItem>
          <MenuItem
            as={Button}
            icon={<SettingsIcon />}
            h="50px"
            bgColor={`${colorThemeMode}_background`}
            color={`${colorThemeMode}_text`}
            borderRadius={"0px"}
            borderTop={"1px solid"}
            borderTopColor={`${colorThemeMode}_tertiary`}
            _hover={{
              bgColor: `${colorThemeMode}_tertiary`,
            }}
            onClick={() => navigate("/settings")}
          >
            <Text fontSize={"16px"} fontWeight={"400"}>
              {translate["settings"]}
            </Text>
          </MenuItem>
          {/* <MenuItem
            as={Button}
            icon={<DollarIcon />}
            h="50px"
            bgColor={`${colorThemeMode}_background`}
            color={`${colorThemeMode}_text`}
            borderRadius={"0px"}
            borderTop={"1px solid"}
            borderTopColor={`${colorThemeMode}_tertiary`}
            _hover={{
              bgColor: `${colorThemeMode}_tertiary`,
            }}
          >
           <Text fontSize={"16px"} fontWeight={"400"}>
              Buy Now
            </Text> 
          </MenuItem> */}
          <MenuItem
            as={Button}
            icon={<LogoutIcon />}
            h="50px"
            bgColor={`${colorThemeMode}_background`}
            color={`${colorThemeMode}_text`}
            borderRadius={"0px"}
            borderTop={"1px solid"}
            borderTopColor={`${colorThemeMode}_tertiary`}
            _hover={{
              bgColor: `${colorThemeMode}_tertiary`,
            }}
            onClick={() => logoutEvent()}
          >
            <Text fontSize={"16px"} fontWeight={"400"}>
              {translate["logout"]}
            </Text>
          </MenuItem>
          <MenuItem
            justifyContent={"end"}
            bgColor={`${colorThemeMode}_background`}
            color={`${colorThemeMode}_secondary`}
            borderTop={"1px solid"}
            borderTopColor={`${colorThemeMode}_tertiary`}
          >
            <Text fontSize="10px" fontWeight="400">
              {version && version}
            </Text>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default UserIconDropDown;
